<template>
  <v-data-table
    :headers="itemDataTableHeaders"
    :items="itemList"
    class="elevation-1"
    :loading="isLoadingItem"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :server-items-length="totalRows"
    :options="currentOptions"
    @update:options="updateOptions"
    :header-props="headerProps"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('item_tool_bar_title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchItem"
          append-icon="mdi-magnify"
          :label="$t('item_search_label')"
          single-line
          hide-details
          clearable
          @input="getSomeItem"
        ></v-text-field>
        <!-- <v-dialog v-model="isShowEditItemDialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ $t('item_card_title') }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                    <v-text-field
                      v-model="editedItem.Number"
                      :label="$t('item_number')"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                    <v-text-field
                      v-model="editedItem.Name"
                      :label="$t('item_name')"
                      disabled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                    <v-text-field
                      v-model="editedItem.Price"
                      :label="$t('item_price')"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                    <v-text-field
                      v-model="editedItem.RepairPrice"
                      :label="$t('quotation_item_repair_price')"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                    <ValidationObserver ref="dialogWarrantyPeriod">
                      <ValidationProvider
                        :name="$t('bom_item_warranty_period')"
                        :rules="{ required: true, regex: /^[0-9]+$/ }"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedItem.WarrantyPeriod"
                          :label="$t('item_warranty_period')"
                          :disabled="isAllTextFieldDisable"
                          required
                          :error-messages="errors[0]"
                          clearable
                        ></v-text-field>
                      </ValidationProvider>
                    </ValidationObserver>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="closeEditedItem"
                :disabled="isAllTextFieldDisable"
              >
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="saveEditedItem"
                :loading="isLoadingSaveBtn"
              >
                {{ $t('common_save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </v-toolbar>
    </template>
    <template v-slot:[`item.UpdateTime`]="{ item }">
      {{ convertToDateTimeFormat(item.UpdateTime) }}
    </template>
    <!-- <template v-slot:[`item.Edit`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
    </template> -->
  </v-data-table>
</template>

<script>
import { HttpItem } from '@/js/http-Manager'
import axios from 'axios'

export default {
  name: 'Item',
  data: () => ({
    isShowEditItemDialog: false,
    itemList: [],
    editedItemIndex: -1,
    searchItem: '',
    editedItem: {
      Number: '',
      Name: '',
      Price: 0,
      WarrantyPeriod: 0,
      RepairPrice: 0,
      UpdateTime: 0
    },
    defaultItem: {
      Number: '',
      Name: '',
      Price: 0,
      WarrantyPeriod: 0,
      RepairPrice: 0,
      UpdateTime: 0
    },
    isLoadingItem: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    itemSource: null,
    updateItemSource: null,
    totalRows: 0,
    isUpdateEventTotal: true,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    itemSomeSource: null
  }),
  async mounted () {
    this.getSomeItem()
    this.getTotalCount()
  },
  computed: {
    itemDataTableHeaders () {
      return [
        {
          text: this.$t('item_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('item_name'), align: 'start', value: 'Name' },
        { text: this.$t('item_price'), align: 'end', value: 'Price' },
        { text: this.$t('item_warranty_period'), align: 'end', value: 'WarrantyPeriod' },
        // { text: this.$t('item_is_month_item'), align: 'end', value: 'IsMonthItem' },
        { text: this.$t('quotation_item_repair_price'), align: 'end', value: 'RepairPrice' },
        { text: this.$t('item_update_time'), align: 'center', value: 'UpdateTime' }
        // { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    async getTotalCount () {
      if (this.isUpdateEventTotal) {
        let param = {
          searchitem: this.searchItem
        }
        let response = await HttpItem.GetDataTableItemCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getSomeItem(val)
    },
    async getSomeItem (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.getTotalCount()
      }
      this.isUpdateEventTotal = true
      this.isLoadingItem = true
      let param = {
        SearchItem: this.searchItem,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy[0]
      }
      if (this.itemSomeSource) {
        this.itemSomeSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.itemSomeSource = cancelToken.source()
      let response = await HttpItem.GetDataTableItem(param, this.itemSomeSource.token)
      this.isLoadingItem = false
      if (response) {
        this.itemList = response.status === 200 ? response.data.Data : []
        this.itemSomeSource = null
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    editItem (item) {
      this.editedItemIndex = this.itemList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.isShowEditItemDialog = true
    },
    closeEditedItem () {
      this.isShowEditItemDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      })
    },

    async saveEditedItem () {
      const isValid = await this.$refs.dialogWarrantyPeriod.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isLoadingItem = true
        if (this.updateItemSource) {
          this.updateItemSource.cancel('cancel')
        }
        let cancelToken = axios.CancelToken
        this.updateItemSource = cancelToken.source()
        await HttpItem.UpdateItem(this.editedItem, this.updateItemSource.token)
        this.updateItemSource = null
        await this.getSomeItem()
        this.closeEditedItem()
      }
    }
  }
}
</script>
